import React from "react";

const MobileEditButton = props => {
  return (
    <button
      className="btn btn-danger btn-lg"
      value={"edit"}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.title.text}
    </button>
  );
};

export default MobileEditButton;
